interface ToggleTabsProps {
  tabs: string[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onClick?: (option: string, index: number) => void;
  activeNavigation?: boolean;
}

export default function ToggleTabs({
  tabs,
  activeTab,
  setActiveTab,
  onClick,
  activeNavigation = true,
}: ToggleTabsProps) {
  return (
    <div className="bg-[#FAFAFA] rounded-full shadow-inner flex w-fit border-2 border-[#FAFAFA]">
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => {
            activeNavigation && setActiveTab(tab);
          }}
          className={`px-4 py-2 rounded-full transition-all duration-100 text-xs font-medium capitalize
            ${
              activeTab === tab
                ? "bg-white text-[#F1935C] shadow transition active:shadow-md"
                : "text-[#6F6D7C]"
            }`}
        >
          {tab.charAt(0).toUpperCase() + tab.slice(1)}
        </button>
      ))}
    </div>
  );
}
